module.exports = __webpack_public_path__ + "img/book_info.b3d7a9e0.svg";